export default {
  SET_SUPPORT_BUSINESS_TYPES: 'SET_SUPPORT_BUSINESS_TYPES',
  SET_ORDER_LIST: 'SET_ORDER_LIST',
  SET_ORDER_LIST_MORE: 'SET_ORDER_LIST_MORE',
  SET_TAKE_OUT_LIST: 'SET_TAKE_OUT_LIST',
  SET_TAKE_OUT_LIST_MORE: 'SET_TAKE_OUT_LIST_MORE',
  SET_BOOK_LIST: 'SET_BOOK_LIST',
  SET_QUEUE_LIST: 'SET_QUEUE_LIST',
  SET_BAKE_LIST: 'SET_BAKE_LIST',
  SET_BAKE_LIST_MORE: 'SET_BAKE_LIST_MORE',
  SET_IS_INVOICE: 'SET_IS_INVOICE',
  SET_IS_HDL: 'SET_IS_HDL',
  SET_USER_INFO: 'SET_USER_INFO',
  SET_INVOICE_STATUS: 'SET_INVOICE_STATUS',
  SET_BRAND_SETTING: 'SET_BRAND_SETTING',
};



// WEBPACK FOOTER //
// ./src/consts/order-list-action-type.js